import { createPermissions } from "./createPermissions";
import { DojoIslandsAccessRules } from "./definitions/DojoIslandsAccessRules";
import { DojoIslandsConfigurations } from "./definitions/DojoIslandsConfigurations";
import type { Permission } from "./definitions/Permission";
import type { Role } from "./definitions/Role";

export { Permission } from "./definitions/Permission";
export { Role } from "./definitions/Role";

const permissionsTracker = createPermissions<Role, Permission>(DojoIslandsAccessRules, DojoIslandsConfigurations);

/**
 * CLIENT API
 *
 * These methods are intended to be used on client-side, where there is
 * a clearly defined current user, so all these methods assume
 * the context of the current user
 */

// special value used as placeholder for the current user assumed for client calls
const CURRENT_USER_ID = "__current_user__";

export const setUserRoles = permissionsTracker.setUserRoles.bind(undefined, CURRENT_USER_ID);
export const userHasRole = permissionsTracker.userHasRole.bind(undefined, CURRENT_USER_ID);
export const userHasPermissions = permissionsTracker.userHasPermissions.bind(undefined, CURRENT_USER_ID);
export const userHasConfigWithValue = permissionsTracker.userHasConfigWithValue.bind(undefined, CURRENT_USER_ID);
/**
 * SERVER API
 *
 * These methods are intended to be used on server-side, where there can
 * be multiple users involved, so callers need to specify which
 * user is being checked
 */
export const serverSetUserRoles = permissionsTracker.setUserRoles;
export const serverUserHasRole = permissionsTracker.userHasRole;
export const serverUserHasPermissions = permissionsTracker.userHasPermissions;
export const serverUserHasConfigWithValue = permissionsTracker.userHasConfigWithValue;

export const { _resetPermissionsState_TEST_ONLY, addRolesUpdatedListener, removeRolesUpdatedListener } = permissionsTracker;
